import { ReactNode } from "react";
import { useBranding } from "@/data/BrandingContext";
import { HelpCircle } from "lucide-react";

export function PortalLayout({ children }: { children: ReactNode }) {
  const { branding } = useBranding();

  return (
    <div className="min-h-screen bg-background">
      {/* ── Portal Header ── */}
      <header className="sticky top-0 z-50 bg-card border-b border-border/60 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-sm">
                {branding.companyName.split(" ").map((w) => w[0]).join("").slice(0, 3)}
              </span>
            </div>
            <div>
              <h1 className="text-sm font-bold tracking-tight text-foreground">{branding.companyName}</h1>
              <p className="text-[10px] text-muted-foreground">Customer Portal</p>
            </div>
          </div>
          <a href="#support" className="text-xs text-primary hover:underline inline-flex items-center gap-1">
            <HelpCircle className="h-3.5 w-3.5" /> Need Help?
          </a>
        </div>
      </header>

      {/* ── Main Content ── */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        {children}
      </main>

      {/* ── Footer ── */}
      <footer className="border-t border-border/40 mt-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 text-center">
          <p className="text-[10px] text-muted-foreground">
            © {new Date().getFullYear()} {branding.companyName} · Powered by {branding.platformName}
          </p>
        </div>
      </footer>
    </div>
  );
}
